module.exports = __webpack_public_path__ + "img/close.18081747.svg";